export default "__VITE_ASSET__CruPB7ap__"